<template>
    <div>
        <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Map view</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group me-2">
                        <h3 class="mx-auto" style="width: 150px;">Simulation</h3>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="play">Start</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="pause">Pause</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="stop">Stop</button>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col">
                        <div >
                        <h6>Base</h6>
                        <video ref="videoBase" class="ratio ratio-16x9" style="--bs-aspect-ratio: 100%;" id="mapView" :key="videoUrlBase">
                            <source v-if="videoUrlBase" :src="videoUrlBase">
                        </video>
                        </div>
                    </div>
                    <div class="col">
                        <div>
                        <h6>{{scenarioName}}</h6>
                        <video ref="videoScenario" class="ratio ratio-16x9" style="--bs-aspect-ratio: 100%;" id="mapView2" :key="videoUrl">
                            <source v-if="videoUrl" :src="videoUrl">
                        </video>
                        </div>
                    </div>
                </div>

                <div class="progress mt-3" style="height:30px">
                    <div ref="mapRun" class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" 
                    :style="{ width: videoBarWidth + '%' }" :aria-valuenow="videoBarWidth" aria-valuemin="0" aria-valuemax="100">
                        {{month}}
                    </div>
                </div>
        

                <div class="row mt-3">
                    <div class="col">
                        <span> 
                        {{descriptionBase}}
                        </span>
                    </div>
                    <div class="col">
                        <span>
                        {{descriptionScenario}}
                        </span>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
//{{ $route.params.indicator }} / {{ $route.params.id }}
import sourceData from '@/data.json'
export default {
    name : 'VideoComponent',
    data() {
        return {
                contents : sourceData,
                currentVideoId : this.$route.params.id,
                vid : document.getElementById("mapView"), 
                vid2 : document.getElementById("mapView2"), 
                progressBar : document.querySelector(".progress-bar"),
                progress : null,
                startVideoTime : 0,
                videoBarWidth : 0,
                vidBase : 310.2,
                month : 'January',
                isVideoPlaying: false
            }
        },
    methods: {
  	    play() {
            this.$refs.videoBase.play()
            this.$refs.videoScenario.play()
            this.startBar()
            this.isVideoPlaying = true
        },
        pause() {
            this.$refs.videoBase.pause()
            this.$refs.videoScenario.pause()
            this.stopProgress()
            this.isVideoPlaying = false
        },
        stop() {
            this.$refs.videoBase.pause()
            this.$refs.videoBase.currentTime = 0
            this.$refs.videoScenario.pause()
            this.$refs.videoScenario.currentTime = 0
            this.resetBar()
            this.isVideoPlaying = false
        },
        startBar(){
            let vidSce = this.getVideo()
            var end = (this.vidBase > vidSce) ? this.vidBase : vidSce;
            clearInterval(this.progress)
            this.progress = setInterval(() => {
                if(this.videoBarWidth == 100) {
                    this.startVideoTime = 0
                    this.videoBarWidth = 0
                    clearInterval(this.progress)
                }else {
                    this.videoBarWidth = (this.startVideoTime * 100)/end + '%'
                    this.videoBarWidth = parseFloat(this.videoBarWidth).toFixed(2)
                    this.month = this.getMonth()
                    this.startVideoTime++
                }
            },1000);
        },
        stopProgress(){
            clearInterval(this.progress);
        },
        resetBar(){
            this.stopProgress();
            this.videoBarWidth = 0
            this.startVideoTime = 0
        },
        getVideo(){
            let vidTime = 0;
            if(this.$route.params.id == '1'){
                vidTime = 303.6;
            } else if(this.$route.params.id == '2'){
                vidTime = 324;
            } else if(this.$route.params.id == '3'){
                vidTime = 425.4;
            } else if(this.$route.params.id == '4'){
                vidTime = 249.6;
            } else if(this.$route.params.id == '5'){
                vidTime = 310.2;
            }    
            return vidTime;
        },
        getMonth(){
            let width = parseInt(this.videoBarWidth)
            let month;
            if(width <= 9)
                month = 'January';
            else if(width <= 16)
                month = 'February';
            else if(width <= 25)
                month = 'March';
            else if(width <= 33)
                month = 'April';  
            else if(width <= 42)
                month = 'May';
            else if(width <= 49)
                month = 'June';
            else if(width <= 57)
                month = 'July';
            else if(width <= 65)
                month = 'August';
            else if(width <= 73)
                month = 'September';
            else if(width <= 81)
                month = 'October';
            else if(width <= 89)
                month = 'November';
            else if(width < 100)
                month = 'December';
            else 
                month = 'Complete';
            return month; 
        }
    },
    computed : {
        progressBarWidth() {
            return this.videoBarWidth + "%";
        },
        descriptionBase : function() {
            if(this.$route.params.indicator == "poverty"){
                return this.contents.indicator.poverty.descriptionBase
            }
            else if(this.$route.params.indicator == "foodsecure"){
                return this.contents.indicator.foodsecure.descriptionBase
            }
        },
        descriptionScenario: function() {
            if(this.$route.params.indicator == "poverty"){
                return this.contents.indicator.poverty.descriptionScenario
            }
            else if(this.$route.params.indicator == "foodsecure"){
                return this.contents.indicator.foodsecure.descriptionScenario
            }
        },
        scenarioName: function() {
            if(this.$route.params.indicator == "poverty"){
                return this.contents.indicator.poverty.scenarios[this.$route.params.id].name
            }
            else if(this.$route.params.indicator == "foodsecure"){
                return this.contents.indicator.foodsecure.scenarios[this.$route.params.id].name
            }
        },
        videoUrlBase() {
            if(this.$route.params.indicator == "poverty"){
                return this.contents.indicator.poverty.scenarios[0].videoUrl
            }
            else if(this.$route.params.indicator == "foodsecure"){
                return this.contents.indicator.foodsecure.scenarios[0].videoUrl
            }
        },
        videoUrl() {
            if(this.$route.params.indicator == "poverty"){
                return this.contents.indicator.poverty.scenarios[this.$route.params.id].videoUrl
            }
            else if(this.$route.params.indicator == "foodsecure"){
                return this.contents.indicator.foodsecure.scenarios[this.$route.params.id].videoUrl
            }
        }
    },
     watch:{
        $route (to, from){
            this.stop()
         }
     }   
}

</script>